import React from "react";
import { WifiOff } from "lucide-react";
import { Alert, AlertDescription } from "@bitsentry-ce/components/ui/alert";
import { useOnlineStatus } from "../hooks/useOnlineStatus";
import { useTranslation } from "@bitsentry-ce/i18n";

export function OfflineIndicator() {
  const { t } = useTranslation();
  const isOnline = useOnlineStatus();

  if (isOnline) {
    return null;
  }

  return (
    <Alert
      variant="destructive"
      className="fixed bottom-4 right-4 w-auto max-w-sm z-50"
    >
      <WifiOff className="h-4 w-4" />
      <AlertDescription>
        {t("common.offlineIndicator.youAreCurrentlyOfflineSome")}
      </AlertDescription>
    </Alert>
  );
}
